import { NavLink, Outlet } from "react-router-dom";
import { BarChart3, Cog, MessageSquare } from "lucide-react";
import { cn } from "@/lib/cn";

interface NavItem {
  to: string;
  label: string;
  icon: typeof MessageSquare;
}

const NAV_ITEMS: NavItem[] = [
  { to: "/chat", label: "Chat", icon: MessageSquare },
  { to: "/ops", label: "Ops", icon: Cog },
  { to: "/biz", label: "Biz", icon: BarChart3 },
];

export default function Layout() {
  return (
    <div className="flex h-full flex-col">
      <header className="border-b border-border bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-6 px-4">
          <Brand />
          <nav className="flex items-center gap-1" aria-label="Primary">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    "inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                    "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                    isActive && "bg-accent text-accent-foreground",
                  )
                }
              >
                <item.icon className="h-4 w-4" aria-hidden="true" />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="flex-1 overflow-hidden">
        <div className="mx-auto h-full max-w-6xl px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function Brand() {
  return (
    <div className="flex items-center gap-2">
      <div
        aria-hidden="true"
        className="grid h-8 w-8 place-items-center rounded-md bg-primary/15 text-primary"
      >
        <span className="font-mono text-xs font-bold tracking-tight">CoS</span>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-semibold">Cockpit</span>
        <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
          Chief of Staff
        </span>
      </div>
    </div>
  );
}
